import React from 'react';
import PropTypes from 'prop-types';
import { getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { tracksWidth, arrowWidth } from "../../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Connector1CBlue1ARed = ({ state, workState }) => (
	<g id="Track-1C-blue" transform="translate(800.000000, 728.000000)">
		<g id="line" transform="translate(0.000033, -0.000013)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
       strokeWidth={tracksWidth}
		>
      <path
        d="M150.481567,145.563613 C165.606567,129.876613 172.826567,108.066613 169.896567,86.3066134 L169.742567,85.1576134 C166.700567,62.5656134 174.794567,39.9006134 191.460567,24.3466134 L209.682567,7.3396134 C214.400567,2.9366134 221.705567,2.8806134 226.490567,7.2116134 C230.867567,11.1726134 231.204567,17.9336134 227.242567,22.3106134 C227.085567,22.4836134 226.923567,22.6516134 226.755567,22.8146134 L206.575567,42.3676134"

      />

      <TrackArrow
        transform="translate(151.999967, 144.000013) rotate(-45.000000) translate(-151.999967, -144.000013) "
        points="155.999967 152.000013 147.999967 144.000013 155.999967 136.000013"
      />

      <line x1="222.999967" y1="4.71629012" x2="245.917409" y2="0.576505869"/>
      <line x1="55.4999666" y1="231.500013" x2="145.999967" y2="152.500013"/>

			{/*<polyline*/}
			{/*	id="arrow"*/}
			{/*	strokeWidth={arrowWidth}*/}
			{/*	strokeLinejoin="round"*/}
			{/*	transform="translate(151.999967, 140.000013) rotate(-45.000000) translate(-151.999967, -140.000013) "*/}
			{/*	points="155.999967 148.000013 147.999967 140.000013 155.999967 132.000013"*/}
			{/*/>*/}
		</g>
	</g>
);

Connector1CBlue1ARed.propTypes = {};

export default Connector1CBlue1ARed;
